module.exports = __webpack_public_path__ + "1793882494189/images/logo.cb067f8.png";